import { useQuery } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'

import { QUERY_GC_TIME_MS, QUERY_STALE_TIME_MS } from '@/config/constants'
import { fetchClaimDetail } from '@/features/claims/api/api'
import { requireAuthToken } from '@/lib/api'
import { claimsKeys } from '@/lib/queryKeys'

export function useClaimDetailQuery(claimId: string | null | undefined) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useQuery({
    queryKey: claimsKeys.detail(organization?.id, claimId),
    enabled: Boolean(organization?.id && claimId),
    queryFn: async ({ signal }) => {
      if (!claimId) throw new Error('claimId is required')
      const token = await requireAuthToken(getToken)
      return fetchClaimDetail(token, claimId, signal)
    },
    staleTime: QUERY_STALE_TIME_MS,
    gcTime: QUERY_GC_TIME_MS,
    refetchOnWindowFocus: false,
  })
}
